export default {"src":"/_next/static/media/hero.40e469ba.svg","height":420,"width":620,"blurWidth":0,"blurHeight":0};